module.exports = __webpack_public_path__ + "img/align-top.52cd8078.svg";